<template>
	<span>{{topicLabel}}</span>
</template>
<script>
	export default {
		props: ['topics', 'topicId'],
		computed: {
			topicLabel: function(){
				var self = this;
				var filtered = this.topics.filter(function(topic){
					return topic.value == self.topicId;
				});
				return filtered[0].label;
			}
		}
	};
</script>